export enum RugbyUnionEventDetailId {
  WeatherConditions = 8,
  PeriodLength = 16,
  NumberOfPeriods = 17,
  FirstHalfStartDate = 19,
  SecondHalfStartDate = 20,
  PitchConditions = 36,
  FirstExtraHalfStartDate = 44,
  SecondExtraHalfStartDate = 45,
  ExtraPeriodLength = 50,
  TimerDirection = 124,
  BallMovement = 160,
  PenaltiesStartDate = 175,
  HasLineups = 205,
  EventType = 257,
}
